export const setHttp = (link: string): string => {
  if (link && link.search(/^http[s]?:\/\//) === -1) {
    return `http://${link}`
  }
  return link
}
